import { StyledTextButton } from './TextButton.styles';
import type { TextButtonProps } from './TextButton.types';

export const TextButton = ({ size = 'sm', children, ...props }: TextButtonProps) => (
  <StyledTextButton data-size={size} type="button" {...props}>
    {children}
  </StyledTextButton>
);
